import {LOCATION_CHANGE} from 'react-router-redux';
import googleAnalytics from 'services/googleAnalytics';
import * as thunkActionConstants from 'utils/redux/thunkActionConstants';
import MixpanelService from "../../services/mixpanel";

const analytics = store => next => action => { // eslint-disable-line no-unused-vars
  let url = '';

  switch(action.type) {
    case LOCATION_CHANGE:
      url = action.payload.pathname + action.payload.search;
      googleAnalytics.eventPageView(url);
      break;
    case "LOGIN_USER_SUCCESS":
    case 'VERIFY_OTP_LOGIN_REQUEST_SUCCESS':
      MixpanelService.identify(action.payload.user.id);
      break;
    // case "REDIRECT_TO_RESET_PASSWORD":
    // case "LOGOUT_USER":
    // case "LOGIN_USER_FAILURE":
    // case "LOGIN_RESET":
    //   MixpanelService.reset();
    //   break;
    case "TRACK_EVENT":
      MixpanelService.track(action.payload.event, action.payload.properties);
      break;
  }

  switch(action.status) {
    case thunkActionConstants.ACTION_STATUS_FAIL:
      // mixpanel.track('failed_server_request', {
      //   action: action.type,
      //   errorData: _get(action, "error.response.data", ""),
      //   errorStatus: _get(action, "error.response.status", "")
      // });
      break;
    default:
      break;
  }

  const result = next(action);
  return result;
};

export default analytics;



// WEBPACK FOOTER //
// ./src/store/middleware/analytics.js